import {
  HubSpotAnalyticsTrackerConfiguration,
  Tracker,
  TrackerType,
  TrackingEventInfo,
} from '@trustedshops/tswp-core-analytics';

import { LogService } from '@trustedshops/tswp-core-common';

export class HubspotAnalyticsTracker implements Tracker {
  private _hsq;
  private readonly _id: string | undefined;
  public get id(): string {
    return this._id as string;
  }

  public get type(): TrackerType {
    return TrackerType.HubSpotAnalytics;
  }

  public constructor(
    private readonly _config: HubSpotAnalyticsTrackerConfiguration,
    private readonly _logService: LogService
  ) {
    this._id = this._config.id;
  }

  public async trackEvent({eventType, eventParameters}: TrackingEventInfo): Promise<void> {
    this._logService.debug(
      '@trustedshops/tswp-core-analytics:HubspotAnalyticsTracker',
      `Tracking event to ${this._config.id}`,
      {eventType, eventParameters}
    );

    this._hsq.push(eventType);
    this._hsq.push(...(eventParameters ?? []));
  }

  public initialize(eventsQueue = []): void {
    this._logService.debug(
      '@trustedshops/tswp-core-analytics:GoogleAnalyticsTracker',
      `Initializing tracker for property "${this._config.id}" with configuration`,
      this._config
    );
    this._hsq = (window as any)?._hsq ?? eventsQueue;
  }
}
